"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardNavegacao = void 0;
var estiloTemplateModule = require('./CardNavegacao.module.scss');
var react_1 = __importDefault(require("react"));
var CardNavegacao = function (_a) {
    var children = _a.children, onClick = _a.onClick, style = _a.style;
    return (react_1.default.createElement("div", { className: estiloTemplateModule.principal, onClick: function () { return onClick; }, style: style }, children));
};
exports.CardNavegacao = CardNavegacao;
